import script from "./Step1PersonalData.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1PersonalData.vue?vue&type=script&setup=true&lang=js"

import "./Step1PersonalData.vue?vue&type=style&index=0&id=c6e0fe92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6e0fe92"]])

export default __exports__